import { Alert, AppThemeProvider, Card, Caption, Heading, Stack } from '@srichaitra/ui';
import { labels } from '@srichaitra/constants';

/**
 * Shown when the application cannot start at all.
 *
 * There is exactly one way to get here: config/app.ini was missing, unreadable
 * or invalid. That is a deployment fault rather than a user error, so the
 * message names the file — whoever sees this screen is the person who can fix
 * it, and "something went wrong" would waste their time.
 *
 * It brings its own theme provider because it renders instead of the app, not
 * inside it: there is no store, no router and no theme in scope at this point.
 */
export function StartupError({ detail }) {
  return (
    <AppThemeProvider>
      <Stack gap={6} sx={{ maxWidth: 560, mx: 'auto', my: 12, px: 6 }}>
        <Stack gap={1}>
          <Heading level={1} size="h2">
            {labels.app.name}
          </Heading>
          <Caption>{labels.app.tagline}</Caption>
        </Stack>

        <Card>
          <Alert tone="error" title={labels.startup.failedHeading}>
            {detail}
          </Alert>
        </Card>
      </Stack>
    </AppThemeProvider>
  );
}
